import { useQuery } from '@tanstack/react-query';
import { actorService, tagService } from '../api/actors';
import type { Actor, TagItem } from '../types/entities/actor.entity';

/** Workspace actors (user + active bots) for assignee pickers. */
export const useActors = () =>
    useQuery<Actor[]>({
        queryKey: ['actors'],
        queryFn: () => actorService.list(),
        staleTime: 60_000,
    });

/** Workspace tags shared by tasks, projects and assets. */
export const useTags = () =>
    useQuery<TagItem[]>({
        queryKey: ['tags'],
        queryFn: () => tagService.list(),
        staleTime: 30_000,
    });
